import { defineMessages } from "react-intl";

const baseId = "t.components.modals.customModal.";

export default defineMessages({
  close: {
    id: baseId + "close",
    defaultMessage: "Close",
  },
});
